import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { GETDashboardService } from '../dashboard.service';
import { SearchFilters } from '../search-panel/search-panel.model';
import { ImplementOverviewModel } from '../dashboard.model';
import { Router } from '@angular/router';
import { GETDashboardColumnsVM } from '../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { DashboardColumnOrderDialogComponent } from './dashboard-column-order-dialog/dashboard-column-order-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { NotificationsService } from 'angular2-notifications';

let ELEMENT_DATA: ImplementOverviewModel[] = null;
@Component({
  selector: 'app-implement-overview',
  templateUrl: './implement-overview.component.html',
  styleUrls: ['./implement-overview.component.scss']
})
export class ImplementOverviewComponent implements OnInit {

   // Search Parameters
   @Input() searchParameters: SearchFilters = new SearchFilters();

   // Favourite Id
   @Input() favouriteId: number = 0;

   // Favourite Name

   favouriteName: string = "";
   length = 100;
   pageSize = 50;
   pageIndex :number=0;
   pageSizeOptions: number[] = [20,50,100];
   recordCount: number = 100;
   ImplementDetalisList:ImplementOverviewModel[];
   loading:boolean=false;
   GETDashboardColumnsList:GETDashboardColumnsVM[]=[]
   GETDashboardColumnsList_:GETDashboardColumnsVM[]=[]
   pageEvent: PageEvent;
   displayedColumns = ['condition','Customer', 'Jobsite', 'Make', 'AssetType','AssetDefinition', 'SerialNo', 'AdditionalSerial', 'ImpBudget', 'Life','Residual','TotalLife', 'RemovelDate', 'Status','WarrantyStatus','BuildNo','NextInspection','LastInspection','Flag' ];     
   dataSource =  new MatTableDataSource<any>();
   @ViewChild(MatSort) sort!: MatSort;
   dataSource1: any[] = [];
   sortName: string ='LastInspectionDate';
   sortOrder: string = 'desc';
  // @ViewChild(MatSort) sort: MatSort;
  showBar:boolean=false
  // @ViewChild(MatSort) set matSort(sort: MatSort) {
  //   sort.sortChange.subscribe((sortData) => {
  //     this.sortName = sortData.active;
  //     this.sortOrder = sortData.direction;
  //     this.pageIndex = 0;
  //     this.loadimp_Overview(); // This makes the server call
  //   });
  // }
  
 
   
  constructor(private _dashboardService: GETDashboardService,private _router: Router,
    private _favouritesService: FavouriteDialogService,
    private _notify: NotificationsService,
    private readonly _pref: PreferencesService, public dialog: MatDialog,) { }

  ngOnInit() {
  console.log("this.favouriteId", this.favouriteId)
    if (this.favouriteId > 0) {
      console.log("fav id", this.favouriteId)
      //this.loading=true;
        this.loadfavouriteImp_View();
    } else {
      if (this.searchParameters !== undefined && this.searchParameters != null) {
             //this.loading=true;
                this.loadimp_Overview();
            }
          }
         
         
  }


  
  loadfavouriteImp_View(){
    this.loading=true;
    var params: SearchFilters = {
      customer: [],
      jobsite: [],
      equipment: [],
      make: [],
      makeUC: [],

      model: [],
      implement: [],
      ImplementTypes: [],
      ComponentTypes: [],

      onEq: 3,
      evalA: false,
      evalB: false,
      evalC: false,
      evalX: false,
      NoImps: false,
      family: [],
      assetSerial: [],
      GETType: [],
      PageNumber: this.pageIndex,
      PageSize: this.pageSize
    };

  this._favouritesService.LoadFavouriteDetails(this.favouriteId).subscribe(r => {
    this.favouriteName = r.FavouriteName;
  });
 // console.log("param", params)
          this._dashboardService.PerformFavoriteSearchImplementOverview(params,this.favouriteId).subscribe(result=>{
           // console.log("resultimplemnt22222", result)
            this.ImplementDetalisList=result;
            this.loading=false;
            this.dataSource1 =  this.ImplementDetalisList
           // console.log("sort",this.sort)
            // setTimeout(() => {
            //   console.log(this.sort) //not undefined
            //   this.dataSource.sort = this.sort; 
            // })
          
            
    })
    

    //load column details from favourite TT-5616
    
    let dashboardcolumnsFav=[]
    this._favouritesService.LoadDashboardColumnsFavouriteforTable(this.favouriteId).subscribe(res=>{
      console.log(res)
      this.GETDashboardColumnsList=res
      for(var i=0; i<this.GETDashboardColumnsList.length; i++){

        //set column order
        dashboardcolumnsFav.push(this.GETDashboardColumnsList[i].Name)

       let make = this.GETDashboardColumnsList.find(e => e.columnId ==4 )
       if(make.ckecked==false){this.Make=false}

       let type = this.GETDashboardColumnsList.find(e => e.columnId ==5 )
       if(type.ckecked==false){this.Type=false}

       let sno = this.GETDashboardColumnsList.find(e => e.columnId ==6 )
       if(sno.ckecked==false){this.SerialNo=false}

       let alt = this.GETDashboardColumnsList.find(e => e.columnId ==7 )
       if(alt.ckecked==false){this.AltSerialNo=false}

       let impBudget = this.GETDashboardColumnsList.find(e => e.columnId ==8 )
       if(impBudget.ckecked==false){this.IMPBudget=false}

       let life = this.GETDashboardColumnsList.find(e => e.columnId ==9 )
       if(life.ckecked==false){this.Life=false}

       let resdual = this.GETDashboardColumnsList.find(e => e.columnId ==10 )
       if(resdual.ckecked==false){this.Residual=false}

       let totalLife = this.GETDashboardColumnsList.find(e => e.columnId ==11 )
       if(totalLife.ckecked==false){this.TotalLife=false}

       let repdate = this.GETDashboardColumnsList.find(e => e.columnId ==12 )
       if(repdate.ckecked==false){this.ReplacementDate=false}

       let status = this.GETDashboardColumnsList.find(e => e.columnId ==13 )
       if(status.ckecked==false){this.Status=false}

       let wstatus = this.GETDashboardColumnsList.find(e => e.columnId ==14 )
       if(wstatus.ckecked==false){this.WarantyStatus=false}

       let bulidNo = this.GETDashboardColumnsList.find(e => e.columnId ==14 )
       if(bulidNo.ckecked==false){this.BuildNo=false}

       let nextInspection = this.GETDashboardColumnsList.find(e => e.columnId ==15 )
       if(nextInspection.ckecked==false){this.NextInspection=false}

       let lastInspection = this.GETDashboardColumnsList.find(e => e.columnId ==16 )
       if(lastInspection.ckecked==false){this.LastInspection=false}

       let Flag = this.GETDashboardColumnsList.find(e => e.columnId ==17 )
       if(Flag.ckecked==false){this.Flag=false}

       let assetType = this.GETDashboardColumnsList.find(e => e.columnId == 18 )
       if(Flag.ckecked==false){this.Flag=false}
      }

      //set show/Hide columns
      for(var i=0; i<this.GETDashboardColumnsList.length; i++){
      var index= this.GETDashboardColumnsList.indexOf(this.GETDashboardColumnsList[i])
      if (this.GETDashboardColumnsList[i].ckecked === false) {
         this.removeArrayelement(dashboardcolumnsFav, this.GETDashboardColumnsList[i].Name)
       } 
      
    }

     this.displayedColumns=dashboardcolumnsFav

    })
    //end code TT-5626
  }
  onUserPaginateChange(event: PageEvent) {
    console.log(event);
    // this.reloadUsers(event.pageIndex + 1, event.pageSize);
    // this.reloadUsers(event.pageIndex + 1, event.pageSize);
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadimp_Overview()
  }
onSortChange(sort: Sort) {
  let sortName = sort.active;
console.log("sortName:",sortName);
  // Map UI field to backend field
  if (sortName === 'status') {
    sortName = 'equipmentunitno'; // send this to the backend instead
  }
  this.sortName = sortName;
  this.sortOrder = sort.direction;
  this.pageIndex = 0;
  this.loadimp_Overview();
}
  loadimp_Overview(){
    this.loading=true;
    var params: SearchFilters = {
      customer: this.searchParameters.customer,
      jobsite: this.searchParameters.jobsite,
      equipment: this.searchParameters.equipment,
      make: this.searchParameters.make,
      makeUC: this.searchParameters.makeUC,

      model: this.searchParameters.model,
      implement: this.searchParameters.implement,
      ImplementTypes: this.searchParameters.ImplementTypes,
      ComponentTypes: this.searchParameters.ComponentTypes,

      onEq: this.searchParameters.onEq,
      evalA: false,
      evalB: false,
      evalC: false,
      evalX: false,
      NoImps: false,
      family: this.searchParameters.family,
      assetSerial: this.searchParameters.assetSerial,
      GETType: this.searchParameters.GETType,
      PageNumber: this.pageIndex + 1,
      PageSize: this.pageSize,
      sortName: this.sortName,
      sortOrder: this.sortOrder
    };


this._dashboardService.PerformDashboardSearchImplementOverview(params).subscribe(result=>{
   
//    this.dataSource.data  = result;
//    this.recordCount = result[0].TotalCount;
//     this.ImplementDetalisList=result;
//     this.loading=false;
//     })
//   }

if (result && result.length > 0) {
  this.dataSource1  = result;
  console.log('reSULT',result);
  console.log(this.dataSource1);
  this.recordCount = result[0].TotalCount;
   this.ImplementDetalisList=result;
 }else{
   this._notify.warn('No Record(s) Found!')
 }
   this.loading=false;
   })
 }

  openImplementDetails(id) {
    //this._router.navigate(['implementdetails/', id]).then(result => { window.open( '_blank'); });
   window.open('/implementdetails/' + id, '_blank');
//   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
//     if(res=="True"){
//       this._router.navigate(['/implementdetails', id]);
//     }else{             
//       window.open('/implementdetails/' + id, '_blank');
     
//     }
// });
}
openEquipmentDetails(id) {
  //this._router.navigate(['implementdetails/', id]).then(result => { window.open( '_blank'); });
 // window.open('/get-equipment/' + id, '_blank');

 this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
  if(res=="True"){
    this._router.navigate(['/get-equipment', id]);
  }else{             
    window.open('/get-equipment/' + id, '_blank');
   
  }
});
}
getEvalClass(wornPct: number) {
  if (wornPct <= 30) {
    return " WornPctCell evalColorA";
  }
  else if ((wornPct > 30) && (wornPct <= 60)) {
    return " WornPctCell evalColorB";
  }
  else if ((wornPct > 60) && (wornPct <= 80)) {
    return " WornPctCell evalColorC";
  }
  else if (wornPct > 80) {
    return "WornPctCell evalColorX";
  }

  return " WornPctCell noEval";

}//for now

OpenInspectionPage(equipmentId:number,LastInspectionId:number){
  console.log('/get-interpretation/inspection/'+equipmentId +'/'+LastInspectionId)
  //this._router.navigate(['/get-interpretation/inspection/'+equipmentId +'/'+LastInspectionId ]);
  window.open('/get-interpretation/inspection/' + equipmentId + '/' + LastInspectionId, '_blank')

}

getColour(residual:number, life:number, budget:number){
  var total = residual+life;
  if (total < budget) {
    return "WornPctCell evalColorX";
  }else{
    return " WornPctCell evalColorA";
  }
}




// Customer =true
// Jobsite =true
Make  =true
Type=true
SerialNo=true
AltSerialNo=true
IMPBudget=true
Life=true
Residual=true
ReplacementDate=true
Status=true
WarantyStatus=true
BuildNo=true
TotalLife=true
NextInspection=true
LastInspection=true
Flag=true
assetType= true





changeCheckbox(value: boolean, key, index: number) {
  if (value === false) {
    this.removeArrayelement(this.displayedColumns, key)
  } else {
    this.displayedColumns.splice(index, 0, key)
  }
}

removeArrayelement(arr, key) {
  let a = arguments, L = a.length, ax;
  while (L > 1 && arr.length) {
    key = a[--L];
    while ((ax = arr.indexOf(key)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
}

OpenOrderDilog(){
  const dialogRef = this.dialog.open(DashboardColumnOrderDialogComponent, {
    disableClose:true,
    data: { 
      displayedColumns: this.displayedColumns
        
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    console.log("res",res)
    this.displayedColumns=res
 
  });
}

ShowHidefield(){
  this.showBar=!this.showBar
}

}
